import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss',
    standalone: false
})
export class NotFoundComponent {
  redirectToHome() {
    window.location.href = '/dashboard';
  }
  throwIssue() {
    throw new Error('This is a test error');
  }
}
